import { getErrorMessage, handleApiError } from "../utils/axios-error";
import axiosClient from "../utils/fetchAxiosClient";

/**
 * Domain request sent to hub-api.
 * ARCHITECTURE: Only user-entered fields should be sent.
 * Hub-api derives/sets: encrypted, customIntegrationEnabled, linkedDomains, etc.
 */
export interface DomainRequest {
  // User-entered fields (common)
  id: string;
  enabled: boolean;
  type?: "google" | "O365";
  // provider is optional - hub-api derives from 'type' if not provided
  provider?: "google" | "office365";

  // Google-specific user-entered fields
  emailAddress?: string;
  credentials?: string;

  // O365-specific user-entered fields
  graphApiUrl?: string;
  useUserPrincipalName?: boolean;
  clientId?: string;
  clientSecret?: string;
  tenantId?: string;
  useRoosterBot?: boolean;
  clientSecretExpiryDate?: string;

  // Hub-api derived fields (not sent by frontend, but included for type compatibility)
  encrypted?: boolean;
  customIntegrationEnabled?: boolean;
}

export interface AddDomainsRequest {
  domains: DomainRequest[];
  uuid: string; // Required: UUID to look up onboarding record and determine target environment
}

export const domainService = {
  async addDomains(clientId: string, data: AddDomainsRequest) {
    try {
      const response = await axiosClient.post(
        `/tenant-provision/${clientId}/domains`,
        data
      );
      return response.data;
    } catch (error: unknown) {
      console.error("Error adding domains:", getErrorMessage(error));
      throw handleApiError(error);
    }
  }
};
